var StatusClienteEnum = {
    AGUARDANDO_CONFIGURACAO: {
        enumName: 'AGUARDANDO_CONFIGURACAO',                      
        name: 'Aguardando Configuracao'
    },
    AGUARDANDO_INSTALACAO: {
        enumName: 'AGUARDANDO_INSTALACAO',  
        name: 'Aguardando Instalacao'      
    },
    INSTALADO: {
        enumName: 'INSTALADO',  
        name: 'Instalado'      
    },
    get(value) {        
        if(value === null)
            return StatusClienteEnum.AGUARDANDO_CONFIGURACAO;

        var array = Object.values(StatusClienteEnum);
        var statusClienteEnumFound = {};

        array.forEach(element => {
            if(element.enumName === value) {
                statusClienteEnumFound = element;      
                return ;          
            }            
        });   
        
        return statusClienteEnumFound;
    }
}

export default StatusClienteEnum;